import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Box sx={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', py: 6 }}>
      <Typography variant="h2" color="primary" gutterBottom>
        {t("notFound.title")}       
      </Typography>
      <Typography variant="h5" gutterBottom>
        {t("notFound.subtitle")}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {t("notFound.description")}
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate('/')}>{t("notFound.backHome")}</Button>
    </Box>
  );
}